export const statusColors = {
  'Pending': 'bg-red-500',
  'In Progress': 'bg-yellow-400',
  'Resolved': 'bg-green-500',
  'Cancelled': 'bg-neutral-200-400',
  'Open': 'bg-blue-500',
}

export const CONTENT_REPORT_STATUS = {
  pending: {
    label: 'Pending',
    className: 'bg-neutral-200 text-gray-800',
    key: 'pending',
  },
  in_progress: {
    label: 'In Progress',
    className: 'bg-yellow-200 text-yellow-800',
    key: 'in_progress',
  },
  resolved: {
    label: 'Resolved',
    className: 'bg-green-200 text-green-800',
    key: 'resolved',
  },
  removed: {
    label: 'Removed',
    className: 'bg-red-200 text-red-800',
    key: 'removed',
  },
}

export const SUPPORT_TICKET_STATUS = {
  pending: {
    label: 'Pending',
    className: 'bg-neutral-200-100 text-gray-800',
    key: 'Pending',
  },
  in_progress: {
    label: 'In Progress',
    className: 'bg-yellow-100 text-yellow-800',
    key: 'In Progress',
  },
  resolved: {
    label: 'Resolved',
    className: 'bg-green-100 text-green-800',
    key: 'Resolved',
  },
}

export const STATUS_OPTIONS = [
  { value: '', label: 'Status' },
  { value: 'Pending', label: 'Pending' },
  { value: 'In Progress', label: 'In Progress' },
  { value: 'Resolved', label: 'Resolved' },
]

export const DATE_PERIODS = {
  today: 'Today',
  yesterday: 'Yesterday',
  this_week: 'This Week',
  last_week: 'Last Week',
  this_month: 'This Month',
  last_month: 'Last Month',
  this_year: 'This Year',
  last_year: 'Last Year',
  custom: 'Custom',
}

export const USER_TYPE_OPTIONS = [
  { value: '', label: 'All User Types' },
  { value: 'wholeseller', label: 'Wholeseller' },
  { value: 'retailer', label: 'Retailer' },
]
